import FormMixin from '@/mixin/form'
import OnboardingPaisModel from '@/model/onboarding/OnboardingPais'

import Step1 from './Steps/Step1' 
import Step2 from './Steps/Step2' 
import Step3 from './Steps/Step3' 
import Step4 from './Steps/Step4'
import Step5 from './Steps/Step5'
import Step6 from './Steps/Step6'

export default {  
    mixins: [ FormMixin ],       
    components: {
        "dados-localizacao": Step1,
        "dados-colaborador": Step2,
        "informacoes-vaga": Step3,
        "requisitos-onboarding": Step4,
        "permissoes-acesso": Step5,
        "sugestao-login": Step6,
    },          
    data () {
        return {
            step: 1,
            onboardingPais: new OnboardingPaisModel().returnModel(),
            necessitaEmail: null                       
        }
    },    
    computed: {  
        title () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.form-title')
        },   
        grupoLocalizacao () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.grupo-localizacao')            
        },
        grupoNovoColaborador () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.grupo-novo-colaborador')            
        },        
        grupoInformacoesAdicionais () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.grupo-informacacao-adicional')            
        },
        grupoInformacoesVaga () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.grupo-informacoes-vaga')            
        },
        grupoRequisitosOnboarding () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.grupo-requisitos-onboarding')            
        },                 
        grupoPermissoesAcesso () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.grupo-permissoes-acesso')            
        },    
        grupoSugestaoLogin () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.grupo-sugestao-login')            
        },                    
        aprovarFinalizar(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.aprovar-finalizar')            
        },        
        finalizar(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.finalizar')            
        },                           
    }
}